/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_OccurrenceInputs */

const en_us2_profile_editors_pain_occurrence = /** @type {(inputs: Profile_Editors_Pain_OccurrenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it hurt now?`)
};

const pt_br2_profile_editors_pain_occurrence = /** @type {(inputs: Profile_Editors_Pain_OccurrenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dói agora?`)
};

const es_419_profile_editors_pain_occurrence = /** @type {(inputs: Profile_Editors_Pain_OccurrenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Te duele ahora?`)
};

const pt_pt2_profile_editors_pain_occurrence = /** @type {(inputs: Profile_Editors_Pain_OccurrenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dói agora?`)
};

const fr_fr2_profile_editors_pain_occurrence = /** @type {(inputs: Profile_Editors_Pain_OccurrenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça fait mal en ce moment ?`)
};

const de_de2_profile_editors_pain_occurrence = /** @type {(inputs: Profile_Editors_Pain_OccurrenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tut es jetzt weh?`)
};

const it_it2_profile_editors_pain_occurrence = /** @type {(inputs: Profile_Editors_Pain_OccurrenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fa male adesso?`)
};

/**
* | output |
* | --- |
* | "Does it hurt now?" |
*
* @param {Profile_Editors_Pain_OccurrenceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_occurrence = /** @type {((inputs?: Profile_Editors_Pain_OccurrenceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_OccurrenceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_occurrence(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_occurrence(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_occurrence(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_occurrence(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_occurrence(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_occurrence(inputs)
	return en_us2_profile_editors_pain_occurrence(inputs)
});
export { profile_editors_pain_occurrence as "profile-editors.pain_occurrence" }